import React from "react";
import { Link } from "react-router-dom";

import "./NotFoundPage.css";

// a Page-level component that is displayed in the top-level switch when nothing else is matched
// Shouldn't really be possible when using the native clients,
//  but it doesn't hurt to create some forward-facing infrastructure.
class NotFoundPage extends React.Component {
  render() {
    return (
      <div className="page-not-found">
        <h1 className="page-not-found__title">Oops!</h1>
        <p>Page Not Found</p>
        <Link to="/">
          <p>Click here to return to Home</p>
        </Link>
      </div>
    )
  }
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/app/NotFoundPage.js